
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface CatalogPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  catalogTitle: string;
  imageUrl: string;
}

export const CatalogPreviewModal = ({
  isOpen,
  onClose,
  catalogTitle,
  imageUrl,
}: CatalogPreviewModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => onClose()}>
      <DialogContent className="max-w-4xl w-[90vw] bg-white">
        <DialogHeader>
          <DialogTitle>{catalogTitle}</DialogTitle>
        </DialogHeader>
        <div className="flex items-center justify-center bg-muted rounded-lg overflow-hidden">
          <img
            src={imageUrl}
            alt={catalogTitle}
            className="w-auto h-auto max-w-full max-h-[80vh]"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
